/* Regex to know if text are pure letter */
export const regexWord = /^[A-Za-z ]+$/;
/* Regex to know if text are pure numbers */
export const regexNumbers = /^[0-9]+$/;